/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom"; // añadir useLocation
import logoDashboard from "../../assets/img/logo__dashboard.png";
import { resetProject } from "../../actions/proyects.actions";
import { useDispatch } from "react-redux";
import SlideToggle from "react-slide-toggle";

const Sidebar = ({ collapsed, onToggle }) => {
  const location = useLocation();
  const [hiddenSubMenu, setHiddenSubMenu] = useState({
    0: false, 
    1: false,
    2: false,
    3: false,
    4: false,
    5: false
  });
  
  const dispatch = useDispatch();
  
  const MENU_OPTIONS = [{
    title: "Resultado Operativo",
    icon: () => <i className="nav-icon fas fa-chart-pie"></i>,
    child: [{
      title: "Proyectos",
      onClick: () => dispatch(resetProject()),
      to: "/projects",
    }, {
      title: "Partida De Control General",
      onClick: () => dispatch(resetProject()),
      to: "/pc-general",
    }, {
      title: "Unidad De Negocios",
      onClick: () => dispatch(resetProject()),
      to: "/business",
    }, {
      title: "Lucro",
      onClick: () => dispatch(resetProject()),
      to: "/lucro",
    }]
  }, {
    title: "Indicadores Logísticos",
    icon: () => <i className="nav-icon far fa-chart-bar"></i>,
    child: [
    //   {
    //   title: "Gastos",
    //   onClick: () => dispatch(resetProject()),
    //   to: "/gastos",
    // }, 
    {
      title: "Gastos V2",
      onClick: () => dispatch(resetProject()),
      to: "/indicadores-logisticos-gastos",
    }, 
    // {
    //   title: "Partida de Control",
    //   onClick: () => dispatch(resetProject()),
    //   to: "/gastos-pc",
    // }, 
    {
      title: "Partida de Control V2",
      onClick: () => dispatch(resetProject()),
      to: "/indicadores-logisticos-partida-de-control",
    }, 
    // {
    //   title: "Partida de Control General",
    //   onClick: () => dispatch(resetProject()),
    //   to: "/gastos-pc-general",
    // }, 
    {
      title: "Partida de Control General V2",
      onClick: () => dispatch(resetProject()),
      to: "/indicadores-logisticos-partida-de-control-general",
    }, ]
  }, {
    title: "Flujo de Caja",
    icon: () => <i className="nav-icon fas fa-exchange-alt"></i>,
    child: [{
      title: "Proyecto y Dimensiones",
      onClick: () => dispatch(resetProject()),
      to: "/flujo-de-caja-proyecto-y-dimensiones",
    }, {
      title: "Partida de Control General",
      onClick: () => dispatch(resetProject()),
      to: "/flujo-de-caja-pc",
    }, {
      title: "Rubros",
      onClick: () => dispatch(resetProject()),
      to: "/flujo-de-caja-rubros",
    }, {
      title: "Categoría tipo documento",
      onClick: () => dispatch(resetProject()),
      to: "/flujo-de-caja-categoria-tipo-documento",
    }, {
      title: "Recurso",
      onClick: () => dispatch(resetProject()),
      to: "/flujo-de-caja-recursos",
    }]
  }, {
    title: "Cuentas x Pagar",
    icon: () => <i className="nav-icon fas fa-exchange-alt"></i>,
    child: [{
      title: "Documentos x proveedor",
      onClick: () => {},
      to: "/facturas",
    }, {
      title: "Saldos x Pagar",
      onClick: () => {},
      to: "/cuentas-x-pagar",
    }]
  }, {
    title: "Cuentas x Cobrar",
    icon: () => <i className="nav-icon fas fa-exchange-alt"></i>,
    child: [{
      title: "Saldos x Cobrar",
      onClick: () => {},
      to: "/cuentas-x-cobrar",
    }]
  }, {
    title: "Tablero",
    icon: () => <i className="nav-icon fas fa-exchange-alt"></i>,
    child: [{
      title: "Asistencia",
      onClick: () => {},
      to: "/asistencia",
    }]
  },
  ];

  // Determinar qué menús tienen un hijo activo
  const getActiveParentIndex = () => {
    for (let idx = 0; idx < MENU_OPTIONS.length; idx++) {
      const menu = MENU_OPTIONS[idx];
      const hasActiveChild = menu.child.some(child => {
        // comparación simple: si la ruta actual empieza con child.to (sin importar parámetros)
        // O usar match exacto? Depende de la estructura. Por ejemplo, si child.to = "/projects"
        // y la ruta actual es "/projects/123", debería coincidir.
        if (!child.to) return false;
        // evitamos coincidencias parciales demasiado genéricas como "/"
        if (child.to === "/") return location.pathname === "/";
        return location.pathname.startsWith(child.to);
      });
      if (hasActiveChild) return idx;
    }
    return -1;
  };

  const activeParentIndex = getActiveParentIndex();

  // Abrir automáticamente el submenú del padre activo (opcional)
  React.useEffect(() => {
    if (activeParentIndex !== -1 && hiddenSubMenu[activeParentIndex] === true) {
      setHiddenSubMenu(prev => ({ ...prev, [activeParentIndex]: false }));
    }
  }, [activeParentIndex, hiddenSubMenu]);

  const itemIsActive = (item) => {
    if (!item.to) return false;
    if (item.to === "/") return location.pathname === "/";
    return location.pathname.startsWith(item.to);
  }

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4" style={{
      width: '100%',
      height: '100%',
    }}>
      <div className="brand-link p-2" style={{ background: "#3c8dbc", height: '50px', display: 'flex', alignItems: 'center' }}>
        <img src={logoDashboard} alt="s10 Logo" className="brand-image img-circle elevation-3" style={{ opacity: 0.8, width: '30px', height: '30px' }} />
        {!collapsed && (
          <span className="brand-text font-weight-light ml-2">Tablero s10</span>
        )}
      </div>

      <div className="sidebar" style={{ overflowY: 'auto', width: '100%' }}>
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            {MENU_OPTIONS.map((menu, index) => {
              const isParentActive = activeParentIndex === index;
              // clase para el padre cuando algún hijo está activo
              const parentNavClass = `nav-link ${isParentActive ? 'active-parent' : ''}`;
              
              return (
                <SlideToggle
                  key={index}
                  duration={300}
                  collapsed={hiddenSubMenu[index]}
                  render={({ toggle, setCollapsibleElement, progress }) => (
                    <li className="nav-item">
                      <a 
                        href="#" 
                        className={parentNavClass}
                        onClick={(e) => {
                          e.preventDefault();
                          toggle();
                          setHiddenSubMenu(prev => ({
                            ...prev,
                            [index]: !prev[index]
                          }));
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        {menu.icon()}
                        {!collapsed && (
                          <p>
                            {menu.title}
                            <i className={`right fas ${hiddenSubMenu[index] ? 'fa-angle-left' : 'fa-angle-down'}`} />
                          </p>
                        )}
                      </a>
                      
                      <div ref={setCollapsibleElement}>
                        {!collapsed && (
                          <ul className="nav nav-treeview" style={{ 
                            display: hiddenSubMenu[index] ? 'none' : 'block',
                            paddingLeft: '1rem'
                          }}>
                            {menu.child.map((item, itemIndex) => (
                              <li key={itemIndex} className="nav-item">
                                <NavLink
                                  to={item.to}
                                  className="nav-link"
                                  onClick={item.onClick}
                                  activeClassName="active"
                                  style={{ 
                                    paddingLeft: '2rem', 
                                    fontSize: '0.85rem',
                                    backgroundColor: itemIsActive(item)  ? '#1e282c' : undefined,
                                    color: itemIsActive(item)  ? 'white' : undefined,
                                  }}
                                  // isActive={}
                                >
                                  <i className="far fa-circle nav-icon" style={{ fontSize: '0.5rem' }} />
                                  <p>{item.title}</p>
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </li>
                  )}
                />
              );
            })}
          </ul>
        </nav>
      </div>

      <style jsx>{`
        .nav-sidebar .nav-link.active-parent {
          background-color: #1e282c !important;
          color: white;
        }
        .nav-sidebar .nav-link.active-parent:hover {
          background-color: #1e282c !important;
        }
      `}</style>
    </aside>
  );
};

export default Sidebar;